import { WithTranslation, withTranslation } from 'react-i18next';
import React from 'react';

import step1Img from './img/practice_location_icon.png';
import step1ImgOff from './img/practice_location_icon-off.png';

import step2Img from './img/provider_profile_icon.png';
import step2ImgOff from './img/provider_profile_icon-off.png';

import step3Img from './img/associated_icon.png';
import step3ImgOff from './img/associated_icon-off.png';
import { getAccessibilityTextFromStep } from '../registration';

interface IOrganizationBreadcrumbProps extends WithTranslation {
    currentStep: number;
}

const OrganizationBreadcrumb = (props: IOrganizationBreadcrumbProps) => {
    const { t } = props;

    return (
        <div className="registration-breadcrumb-container">
            <div className="registration-breadcrumb-item">
                <div className="registration-breadcrumb-text-container">
                    <div
                        className={
                            props.currentStep === 1 ? 'body-large body-large--purple' : 'body-large'
                        }
                    >
                        <div className="accessibility-hidden">
                            {t(getAccessibilityTextFromStep(1, props.currentStep), {
                                ns: 'accessibility',
                            })}
                        </div>
                        {t('form_organization_header_step_1_title')}
                    </div>
                    <div
                        className={
                            props.currentStep === 1
                                ? 'body-medium body-medium--purple'
                                : 'body-medium'
                        }
                    >
                        {t('form_organization_header_step_1_subtitle')}
                    </div>
                </div>
                <img
                    className="registration-breadcrumb-icon"
                    src={props.currentStep === 1 ? step1Img : step1ImgOff}
                    alt={t('form_organization_breadcrumb_step_1_alt_text', { ns: 'accessibility' })}
                />
            </div>
            <div className="registration-breadcrumb-item">
                <div className="registration-breadcrumb-text-container">
                    <div
                        className={
                            props.currentStep === 2 ? 'body-large body-large--purple' : 'body-large'
                        }
                    >
                        <div className="accessibility-hidden">
                            {t(getAccessibilityTextFromStep(2, props.currentStep), {
                                ns: 'accessibility',
                            })}
                        </div>
                        {t('form_organization_header_step_2_title')}
                    </div>
                    <div
                        className={
                            props.currentStep === 2
                                ? 'body-medium body-medium--purple'
                                : 'body-medium'
                        }
                    >
                        {t('form_organization_header_step_2_subtitle')}
                    </div>
                </div>
                <img
                    className="registration-breadcrumb-icon"
                    src={props.currentStep === 2 ? step2Img : step2ImgOff}
                    alt={t('form_organization_breadcrumb_step_2_alt_text', { ns: 'accessibility' })}
                />
            </div>
            <div className="registration-breadcrumb-item">
                <div
                    className="registration-breadcrumb-text-container"
                    aria-label={`${t('form_organization_header_step_3_title')} ${t(
                        'form_organization_header_step_3_subtitle'
                    )}`}
                >
                    <div
                        className={
                            props.currentStep === 3 ? 'body-large body-large--purple' : 'body-large'
                        }
                    >
                        <div className="accessibility-hidden">
                            {t(getAccessibilityTextFromStep(3, props.currentStep), {
                                ns: 'accessibility',
                            })}
                        </div>
                        {t('form_organization_header_step_3_title')}
                    </div>
                    <div
                        className={
                            props.currentStep === 3
                                ? 'body-medium body-medium--purple'
                                : 'body-medium'
                        }
                    >
                        {t('form_organization_header_step_3_subtitle')}
                    </div>
                </div>
                <img
                    className="registration-breadcrumb-icon"
                    src={props.currentStep === 3 ? step3Img : step3ImgOff}
                    alt={t('form_organization_breadcrumb_step_3_alt_text', { ns: 'accessibility' })}
                />
            </div>
        </div>
    );
};

export default withTranslation()(OrganizationBreadcrumb);
